import {
  IRecordById,
  ITableById,
  IFieldById,
  IViewById,
  IViewOption,
  ITableOption,
} from '../../types/core';
import { GetWorkspaceQuery_workspace_users } from '../../../graphql/core/types/GetWorkspaceQuery';

export enum Locale {
  ZH = 'zh',
  EN = 'en',
}

export enum ExitType {
  REFRESH = 'refresh',
  CLOSE = 'close',
}

export interface IMe {
  id?: string;
}

export interface IState {
  isLoading: boolean;
  isLoadingView: boolean;
  isLoadingTableOptions: boolean;
  isViewEmpty: boolean;
  isExpand: boolean;
  canEdit: boolean;
  me: IMe;
  currentWorkspaceId: string;
  currentTableId: string;
  currentViewId: string;
  currentRecordId: string;
  currentBlockId: string;
  viewById: { [key: string]: IViewById };
  tableById: { [key: string]: ITableById };
  recordById: { [key: string]: IRecordById };
  fieldById: { [key: string]: IFieldById };

  tableOptionById: { [key: string]: ITableOption };
  tableOptionsAllIds: string[];
  viewOptionById: { [key: string]: IViewOption };

  visibleNodes: { [key: string]: any };
  locale: Locale;
  users: { [key: string]: any };
  toast: IToastProps | null;
  error: any | null;
  exitType: ExitType | null;
}

export interface IViewResponse {
  viewById: { [key: string]: IViewById };
  tableById: { [key: string]: ITableById };
  recordById: { [key: string]: IRecordById };
  fieldById: { [key: string]: IFieldById };
}

export interface IURLParams {
  workspaceId: string;
  coreId: string;
  tableId: string;
  viewId?: string;
  blockId: string;
  locale?: Locale;
  isExpand?: string;
  sessionId?: string;
  meId?: string;
  hasPermission?: string;
  index: number;
}

export interface IToastProps {
  messageId?: string;
  values?: { [key: string]: number | string };
  message?: string;
  isError?: boolean;
  buttonTitleId?: string;
  onClick?: () => void;
}

export type IReduxUser = Omit<GetWorkspaceQuery_workspace_users, '__typename'>;
